import type { URL } from "@myloc/myloc-utils";
import { endpoint } from "../../../../config/settings";

export const api = {
  bankid: {
    initiateAuth: (): URL => endpoint("/bankid/authentication"),
    collect: (): URL => endpoint("/bankid/collect"),
  },
};
